/**
 * Pre-compiled en messages for Pagination
 * Generated by @internationalized/string-compiler
 * DO NOT EDIT MANUALLY
 */

export default {
  currentPage: `Current page`,
  goToNextPage: `Go to next page`,
  goToPreviousPage: `Go to previous page`,
  itemsPerPage: `Items per page`,
  itemsPerPageText: `items per page`,
  ofTotalPages: (args: Record<string, string | number>) =>
    `of ${args.totalPages}`,
  page: `Page`,
  pagination: `Pagination`,
};
